export const PersonalizedValues = {
    image: null
}
